// DBT-156 — cartelle per il caricamento di un documento.
//
// L'API `GET /documenti/cartelle/` restituisce un ALBERO (radici con
// `sottocartelle` annidate). La tendina del modal leggeva solo il primo livello:
// si vedevano «Documenti generali», «Clienti», … e mai la sottocartella in cui
// l'utente stava lavorando. Qui l'albero si appiattisce in ordine di lettura,
// con la profondita' per l'indentazione, e si ricava il contesto (cartella +
// cliente/fornitore/cantiere) della cartella aperta.

// Lista piatta in profondita': [{ id, nome, parent, cliente, fornitore, cantiere, depth }].
// Accetta anche una lista gia' piatta (nessuna `sottocartelle`): resta com'e'.
export function appiattisciCartelle(albero) {
  var out = [];
  var visti = {};
  function visita(nodi, depth) {
    (nodi || []).forEach(function (c) {
      if (!c || visti[c.id]) return;  // guardia contro nodi ripetuti
      visti[c.id] = true;
      out.push({
        id: c.id, nome: c.nome, parent: c.parent || null,
        cliente: c.cliente || null, fornitore: c.fornitore || null, cantiere: c.cantiere || null,
        depth: depth,
      });
      visita(c.sottocartelle, depth + 1);
    });
  }
  visita(albero, 0);
  return out;
}

// Contesto di caricamento per la cartella `id`: la cartella stessa e la prima
// entita' (cliente, fornitore, cantiere) trovata risalendo i genitori.
// Ritorna valori vuoti ('') se la cartella non c'e': il modal parte vuoto.
export function contestoDaCartella(albero, id) {
  var vuoto = { cartella: '', cliente: '', fornitore: '', cantiere: '' };
  if (!id) return vuoto;
  var piatte = appiattisciCartelle(albero);
  var perId = {};
  piatte.forEach(function (c) { perId[c.id] = c; });
  if (!perId[id]) return vuoto;
  var ctx = { cartella: id, cliente: '', fornitore: '', cantiere: '' };
  var corrente = perId[id];
  var passi = 0;
  while (corrente && passi < 20) {
    if (corrente.cliente) { ctx.cliente = corrente.cliente; break; }
    if (corrente.fornitore) { ctx.fornitore = corrente.fornitore; break; }
    if (corrente.cantiere) { ctx.cantiere = corrente.cantiere; break; }
    corrente = corrente.parent ? perId[corrente.parent] : null;
    passi += 1;
  }
  return ctx;
}

// Messaggio da mostrare quando il caricamento fallisce. Il messaggio di
// validazione su `cartella` (DBT-156: cartella di un'altra entita') e' una frase
// in italiano scritta per l'utente: si mostra. Quelli su `file` NO — alcuni sono
// tecnici («Mismatch tra Content-Type…»), e la Regola 14 vieta di mostrarli.
// Tutto il resto resta il messaggio generico: mai JSON grezzo.
export const ERRORE_UPLOAD_GENERICO = 'Errore upload \u2014 riprova';

export function messaggioErroreUpload(err) {
  var data = err && err.response && err.response.status === 400 ? err.response.data : null;
  if (!data || typeof data !== 'object') return ERRORE_UPLOAD_GENERICO;
  var v = data.cartella;
  var testo = Array.isArray(v) ? v[0] : v;
  return (typeof testo === 'string' && testo.trim()) ? testo : ERRORE_UPLOAD_GENERICO;
}
